import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M12 11h4" />
      <path d="M12 16h4" />
      <path d="M8 11h.01" />
      <path d="M8 16h.01" />
    </svg>
  );
}

export const ClipboardList = (props: IconProps) => renderSvg("clipboard-list", props);
export const ClipboardListIcon = ClipboardList;
export default ClipboardList;
